import { Pipe, PipeTransform } from '@angular/core';

import { DsBadgeTheme } from '@design-system/ds-badge/types/ds-badge-theme.type';
import { FILE_TAG_BADGE_FALLBACK_THEME, FILE_TAG_BADGE_THEMES } from '@properties/file-attachment.properties';

/** Resolves the badge theme for a file attachment tag name. */
@Pipe({
  name: 'fileTagBadgeTheme',
  standalone: true,
})
export class FileTagBadgeThemePipe implements PipeTransform {
  transform(tagName: string | null | undefined): DsBadgeTheme {
    return (tagName && FILE_TAG_BADGE_THEMES[tagName]) || FILE_TAG_BADGE_FALLBACK_THEME;
  }
}
